import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import historicoActions from "../store/historico.actions";
import historicoSelector from "../store/historico.selectors";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import Modal from "./historico.modal";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showModal: false
    };

    const options = {
      filterVersion: 44,
      noStorage: true,
      webStorage: "Deca.Historicos",
      applySearchOnLoad: true
    };

    const columns = [
      {
        dataName: "DataRegistro",
        fieldName: "Data",
        show: true,
        type: "date",
        onlyDate: true,
        removeFilter: true
      },
      {
        dataName: "Origem",
        fieldName: "Origem",
        show: true,
        array: typeArray.origemDeca,
        type: "lista",
        arrayType: "number",
        removeFilter: true
      },
      {
        dataName: "Historico",
        fieldName: "Histórico",
        show: true,
        type: "text",
        removeFilter: true
      }
    ];

    const actions = [
      {
        type: "view",
        onClick: async dataItem => this.onViewItem(dataItem)
      },
      {
        type: "delete",
        onClick: async dataItem => {
          const { historico } = this.props.historicoSelector;
          const { historicos } = historico;
          let index = _.findIndex(historicos, dataItem);
          dataItem.Id
            ? _showError(
                "É permitida a exclusão apenas de históricos inclusos durante a revisão ou retificação. Este histórico não pode ser excluído."
              )
            : await this.props.historicoActions.deleteSagaHistorico(index);
        }
      }
    ];

    const order = [];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };

    this.parameters = {};
  }

  onViewItem(dataItem) {
    this.parameters = dataItem;

    this.setState({ showModal: true });
  }

  render() {
    const { historico } = this.props.historicoSelector;
    const { historicos } = historico;
    const { showModal } = this.state;

    return (
      <Fragment>
        <Modal
          show={showModal}
          prefix={"V"}
          parameters={this.parameters}
          onClose={() => this.setState({ showModal: false })}
        />
        <StaticGrid {...this.config} itens={historicos.asMutable()} />
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    historicoActions
  },
  selectors: {
    historicoSelector
  }
})(Container);
